import React from 'react'
import { IValidationError } from 'pages/Planning/hooks/useWeeklyStudy'
import './validation-alert.css'

interface ValidationAlertProps {
  errors: IValidationError[]
  isDarkMode?: boolean
}

const ValidationAlert: React.FC<ValidationAlertProps> = ({ errors, isDarkMode = true }) => {
  if (errors.length === 0) {
    return null
  }

  const errorMessages = errors.filter((e) => e.type === 'error')
  const warningMessages = errors.filter((e) => e.type === 'warning')

  return (
    <div className={`validation-alerts ${isDarkMode ? 'dark' : 'light'}`}>
      {errorMessages.length > 0 && (
        <div className="validation-alert-section">
          <div className="validation-alert-header error">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z"
                fill="currentColor"
              />
            </svg>
            <span className="validation-alert-title">
              {errorMessages.length === 1
                ? 'Configuração inválida'
                : `${errorMessages.length} problemas encontrados`}
            </span>
          </div>
          <div className="validation-alert-list">
            {errorMessages.map((error, index) => (
              <div key={`error-${index}`} className="validation-alert-item error">
                <p className="validation-alert-message">{error.message}</p>
                {error.details && <p className="validation-alert-details">{error.details}</p>}
              </div>
            ))}
          </div>
        </div>
      )}

      {warningMessages.length > 0 && (
        <div className="validation-alert-section">
          <div className="validation-alert-header warning">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z"
                fill="currentColor"
              />
            </svg>
            <span className="validation-alert-title">
              {warningMessages.length === 1 ? 'Atenção' : `${warningMessages.length} avisos`}
            </span>
          </div>
          <div className="validation-alert-list">
            {warningMessages.map((warning, index) => (
              <div key={`warning-${index}`} className="validation-alert-item warning">
                <p className="validation-alert-message">{warning.message}</p>
                {warning.details && <p className="validation-alert-details">{warning.details}</p>}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default ValidationAlert
